import { useState, useEffect } from 'react';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';

export default function useInitialMilestoneId() {
  const [milestoneId, setMilestoneId] = useState('');

  const clearMilestoneId = () => {
    storage.removeSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY);
    if (milestoneId) {
      setMilestoneId('');
    }
  };

  const clearMilestoneIdByTabId = (tabId?: string) => {
    if (tabId !== 'milestone') {
      clearMilestoneId();
    }
  };

  useEffect(() => {
    const milestoneId =
      storage.getSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_MILESTONE_ID_STORAGE_KEY) || '';
    setMilestoneId(milestoneId);

    return () => {
      clearMilestoneId();
    };
  }, []);

  return { milestoneId, setMilestoneId, clearMilestoneId, clearMilestoneIdByTabId };
}
